import React from "react";

import { Chip } from "@mui/material";

import { SENSOR_CHIP_SX } from "components/sensors/table/chips/sensor-chip-style";
import { SENSOR_STATUS_COLOR } from "components/sensors/table/chips/sensor-status-color";
import { noValueText } from "components/sensors/table/no-value-text";

const PILL_WIDTH = "88px";

export function AlertStatusChip({ inAlert }: { inAlert: boolean }) {
  if (!inAlert) {
    return noValueText("No alerts");
  }
  return (
    <Chip
      size="small"
      sx={{
        ...SENSOR_CHIP_SX,
        width: PILL_WIDTH,
        ...SENSOR_STATUS_COLOR.negative,
      }}
      label="In alert"
    />
  );
}
